<template>
    <div class="foot-bottom-box">
        <span>
            {{title}}
        </span>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        title: String
    }
};
</script>

<style lang="less">
.foot-bottom-box {
    background: #8a3e2f;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.08);
    width: 100%;
    height: 54px;
    position: fixed;
    bottom: 0;
    font-size: 18px;
    color: #ffffff;
    text-align: center;
    line-height: 54px;
    font-weight: 700;
}
</style>
